module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'opj4r4nr',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production',
  },
}
